import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["fullWidthOnMobile", "children", "className"];
var _dec, _class, _class2;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './Content.scss';
var Content = (_dec = withStyles(s), _dec(_class = (_class2 = /*#__PURE__*/function (_PureComponent) {
  _inherits(Content, _PureComponent);
  var _super = _createSuper(Content);
  function Content() {
    _classCallCheck(this, Content);
    return _super.apply(this, arguments);
  }
  _createClass(Content, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        fullWidthOnMobile = _this$props.fullWidthOnMobile,
        children = _this$props.children,
        className = _this$props.className,
        rest = _objectWithoutProperties(_this$props, _excluded);
      return /*#__PURE__*/React.createElement("section", _extends({
        className: classNames(s.container, className, _defineProperty({}, s.fullWidthOnMobile, !!fullWidthOnMobile))
      }, rest), children);
    }
  }]);
  return Content;
}(PureComponent), _defineProperty(_class2, "defaultProps", {
  fullWidthOnMobile: false,
  children: function children() {
    return null;
  },
  className: ''
}), _class2)) || _class);
export { Content as default };